import { useEffect } from 'react'

import LoaderFull from '@space-shell/common/components/loaderFull'
import { withAuth } from '@space-shell/common/hocs/withAuth'
import { AuthUtils } from '@space-shell/common/utils/auth'

const LogoutPage = () => {
  useEffect(() => {
    AuthUtils.reset()
  }, [])

  return <LoaderFull />
}

export default withAuth(LogoutPage)
